"use client";

import { AppLayout } from "components/common/layouts/AppLayout";
import React from "react";

export default function Layout({ children }: { children: React.ReactNode }) {
  return <AppLayout>{children}</AppLayout>;
}
